import { ReactComponent as CheckSVG } from "@assets/icons/ic_check.svg";
import { cn } from "@helpers/utils";
import { Fade } from "@mui/material";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import React from "react";

type BaseMaterialCheckboxProperties = {
    checked?: boolean;
    indeterminate?: boolean;
    disabled?: boolean;
    onChange?: (val: React.SyntheticEvent, checked: boolean) => void;
    borderColor?: string;
    checkedClassName?: string;
    ariaLabel?: string;
    hitAreaPadding?: string;
};

export default function BaseMaterialCheckbox(props: BaseMaterialCheckboxProperties) {
    return (
        <>
            <Checkbox
                sx={{
                    padding: props.hitAreaPadding ?? 0,
                    input: {
                        background: "transparent",
                    },
                }}
                icon={
                    <div
                        className={`border-[1.7px] border-solid h-[20px] w-[20px] rounded-[4px]`}
                        style={{ borderColor: props.borderColor ?? "#D9D6DA" }}
                    ></div>
                }
                checkedIcon={
                    <Fade in={true}>
                        <div
                            className={cn(
                                "flex justify-center items-center h-[20px] w-[20px] rounded-[4px] bg-[#A6DD4C]",
                                props.checkedClassName
                            )}
                        >
                            <CheckSVG className="text-[#fff] w-[15px]" />
                        </div>
                    </Fade>
                }
                indeterminateIcon={
                    <div
                        className={cn(
                            "flex h-[20px] w-[20px] items-center justify-center rounded-[4px] bg-[#A6DD4C]",
                            props.checkedClassName
                        )}
                    >
                        <span className="h-[2px] w-[10px] rounded-full bg-white" />
                    </div>
                }
                checked={props.checked}
                indeterminate={props.indeterminate}
                disabled={props.disabled}
                onChange={props.onChange}
                inputProps={{ "aria-label": props.ariaLabel }}
                disableRipple
            />
        </>
    );
}
